import React, { useState } from "react";
import { Grid, Paper } from "@material-ui/core";
import Chart from "react-apexcharts";
import { stateChart } from "../../../utils/stateChart";

//const initialState = stateChart(['ABIERTOS', 'CERRADOS']);
const initialState = stateChart(["EN EJECUCIÓN", "CERRADOS"]);

const ReportByStatus = ({ data }) => {
  const [state] = useState(initialState);

  const quantityProjectsByState = (isOpen) => {
    const res = data.filter((project) => project.is_open === isOpen);
    return res.length;
  };

  return (
    <Grid item xs={8} sm={8} md={12}>
      <Paper className="paper" style={{ marginTop: "2em" }}>
        <Chart
          options={state.options}
          series={[quantityProjectsByState(1), quantityProjectsByState(0)]}
          type="pie"
          height={380}
          className="chart"
        />
      </Paper>
    </Grid>
  );
};

export default ReportByStatus;
